import * as React from "react";
import "../scss/departureentry.scss"

export interface DepartureEntryProps {
    content:string;
    width:number;
    textAlign:any;
    color?:string;
    fontsize?:string;
    smallercontent?:string;
    lineHeight?:string;
}

export class DepartureEntryComponent extends React.Component<DepartureEntryProps, {}> {
    private myRef:React.RefObject<HTMLDivElement>;
    constructor(props:DepartureEntryProps){
        super(props);
        this.myRef = React.createRef<HTMLDivElement>();
    }
    render(){
        return (
            <div className="departure-wrapper">
            <div ref={this.myRef} className="departure-entry" style={{width:this.props.width, textAlign:this.props.textAlign, lineHeight:this.props.lineHeight}}>
                <span style={{color:this.props.color, fontSize:this.props.fontsize}}>{this.props.content}</span>
                <span style={{color:this.props.color, fontSize:20}}>{this.props.smallercontent}</span>
            </div>
            </div>
        )
    }
    scrollContentPeriodically(){
       let actScroll = this.myRef.current?.scrollTop;
        this.myRef.current?.scrollBy(0,98);
        if(this.myRef.current?.scrollTop === actScroll)
            this.myRef.current?.scrollTo(0,0);
    }
    componentDidMount(){
        setInterval(() => this.scrollContentPeriodically() , 10000);
        
    }
}

export default DepartureEntryComponent;